<template>
  <vue100vh style="position: fixed;width: 100%;">
  <div class="CSChatThai BGwhite">
    <v-toolbar style="background-color: white !important;">
      <v-btn icon @click="toPage()">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <v-toolbar-title>{{$t('LeftSide.friend.addFriend')}}</v-toolbar-title>
    </v-toolbar>
    <v-card-text style="overflow-y: scroll; height: calc(100vh - 64px);">
      <v-container grid-list-md>
        <v-layout wrap align-center>
          <v-flex sm12 md12 lg12 xl12 style="display: flex;justify-content: center;margin-top: 1vh;">
            <v-text-field append-icon="search" :label="$t('LeftSide.addFiend.searching')" solo clearable v-model="search" class="bgsearch" style="color: white !important;" v-on:keyup.enter="searchuser()" @click:append="searchuser()"></v-text-field>
          </v-flex>
          <v-flex  sm12 md12 lg12 xl12 class="CSChatThai" v-if="statussearch == ''">
            <v-layout align-center justify-center column>
              <img src="/static/img/onechat/search.jpg" style="width: 170px;">
              <p>{{$t('LeftSide.addFiend.detailSearch')}}</p>
            </v-layout>
          </v-flex>
          <v-flex  sm12 md12 lg12 xl12 class="CSChatThai" v-else-if="statussearch == 'not found'">
            <v-layout align-center justify-center column>
              <img src="/static/img/onechat/nosearch.png" style="width: 120px; margin-bottom: 20px;">
              <p align="center" >{{$t('LeftSide.addFiend.nodata', {key: search})}}</p>
            </v-layout>
          </v-flex>
          <v-flex  sm12 md12 lg12 xl12 v-else>
            <v-tabs centered color="cyan" dark icons-and-text>
              <v-tabs-slider color="info"></v-tabs-slider>
                <v-tab href="#tab-1" :key="1" style="color: black !important;" v-if="listuser.length !== 0">User
                  <v-badge color="#2562af">
                    <span slot="badge">{{listuser.length}}</span>
                    <v-icon style="color: black !important; font-size: 25px !important;">person</v-icon>
                  </v-badge>
                </v-tab>
                <v-tab href="#tab-2" :key="2" style="color: black !important;" v-if="listbot.length !== 0">Bot
                  <v-badge color="#2562af">
                    <span slot="badge">{{listbot.length}}</span>
                    <!-- <v-icon style="color: black !important; font-size: 25px !important;">fas fa-lock</v-icon> -->
                    <img src='/static/img/icons/bot.svg' style="width: 30px;" class="alligator-turtle">
                  </v-badge>
                </v-tab>
                <!-- <v-tab href="#tab-2" :key="2" style="color: black !important;">Business
                  <v-icon style="color: black !important; font-size: 25px !important;">business</v-icon>
                </v-tab>
                <v-tab href="#tab-3" :key="3" style="color: black !important;">Goverment
                  <v-icon style="color: black !important; font-size: 25px !important;">account_balance</v-icon>
                </v-tab> -->
                <!-- list user -->
                <v-tabs-items>
                  <v-tab-item id="tab-1">
                    <v-list two-line style="overflow-y: scroll; max-height: 40vh;" v-if="listuser.length !== 0">
                    <template v-for="(item, index) in listuser">
                      <v-list-tile>
                        <v-list-tile-avatar >
                          <img v-if="item.user.profilepicture" :src="item.user.profilepicture" class="alligator-turtle">
                          <img  v-else-if="item.user.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                          <img  v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                        <v-list-tile-title v-html="item.user.name" class="text2"></v-list-tile-title>
                      </v-list-tile-content>

                      <v-list-tile-action>
                        <v-btn color="blue darken-1" v-if="item.relation == 'friend'" flat @click.native="chat(item.user.tokenroom)" class="CSChatThai text-transform">{{$t('AnswerQuestion.chat')}}</v-btn>
                        <v-btn color="blue darken-1" v-else-if="item.relation == 'request'" flat @click.native="AcceptReq(index,item)" class="CSChatThai text-transform">{{$t('AnswerQuestion.acceptFriend')}}</v-btn>
                        <v-btn color="red darken-1" v-else-if="item.relation == 'sendrequest'" flat @click.native="RemoveReq(index,item)" class="CSChatThai text-transform">{{$t('AnswerQuestion.cancelRequest')}}</v-btn>
                        <v-btn color="red darken-1" v-else-if="item.relation == 'block'" flat @click.native="unblock(index,item,'user')" class="CSChatThai text-transform">{{$t('AnswerQuestion.unblock')}}</v-btn>
                        <v-btn color="blue darken-1" v-else-if="item.relation == 'self'" flat @click.native="closeDialog()" class="CSChatThai text-transform">{{$t('AnswerQuestion.ok')}}</v-btn>
                        <v-btn color="blue darken-1" v-else-if="(item.relation == 'unknown' || item.relation == 'unfriend') && item.collab_mail == 'true'" flat :loading="loading" @click.native="AddFriendCollab(index, item.user, item.collab_mail)" class="CSChatThai text-transform">{{$t('AnswerQuestion.chat')}}</v-btn>
                        <v-btn color="blue darken-1" v-else-if="(item.relation == 'unknown' || item.relation == 'unfriend') && item.collab_mail == 'false'" flat @click.native="AddFriendCollab(index, item.user, item.collab_mail)" class="CSChatThai text-transform">{{$t('AnswerQuestion.addFriend')}}</v-btn>
                        <!-- <v-btn color="blue darken-1" v-else-if="(item.relation == 'unknown' || item.relation == 'unfriend') && item.collab_mail == 'false'" flat @click.native="AddFriend(index,item.user.tokenuser,item.user.type)" class="CSChatThai">เพิ่มเพื่อน</v-btn> -->
                      </v-list-tile-action>
                      </v-list-tile>
                      <v-divider></v-divider>
                    </template>
                  </v-list>
                  <v-list v-else><h4 style="margin-top: 40px; justify-content: center; display: flex;">{{$t('LeftSide.addFiend.nodata', {key: ''})}}</h4></v-list>
                  </v-tab-item>
                  <!-- list bot -->
                  <v-tab-item id="tab-2">
                    <v-list two-line style="overflow-y: scroll; max-height: 40vh;" v-if="listbot.length !== 0">
                    <template v-for="(item, index) in listbot">
                      <v-list-tile>
                        <v-list-tile-avatar >
                          <img v-if="item.user.profilepicture" :src="item.user.profilepicture" class="alligator-turtle">
                          <img  v-else-if="item.user.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                          <img  v-else src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                        <v-list-tile-title v-html="item.user.name" class="text2"></v-list-tile-title>
                      </v-list-tile-content>

                      <v-list-tile-action>
                        <v-btn color="blue darken-1" v-if="item.relation == 'friend'" flat @click.native="chat(item.user.tokenroom)" class="CSChatThai text-transform">{{$t('AnswerQuestion.chat')}}</v-btn>
                        <v-btn color="blue darken-1" v-else-if="item.relation == 'request'" flat @click.native="AcceptReq(index,item)" class="CSChatThai text-transform">{{$t('AnswerQuestion.acceptFriend')}}</v-btn>
                        <v-btn color="red darken-1" v-else-if="item.relation == 'sendrequest'" flat @click.native="RemoveReq(index,item)" class="CSChatThai text-transform">{{$t('AnswerQuestion.cancelRequest')}}</v-btn>
                        <v-btn color="red darken-1" v-else-if="item.relation == 'block'" flat @click.native="unblock(index,item,'bot')" class="CSChatThai text-transform">{{$t('AnswerQuestion.unblock')}}</v-btn>
                        <v-btn color="blue darken-1" v-else-if="item.relation == 'self'" flat @click.native="closeDialog()" class="CSChatThai text-transform">{{$t('AnswerQuestion.ok')}}</v-btn>
                        <v-btn color="blue darken-1" v-else-if="item.relation == 'unknown' || item.relation == 'unfriend'" flat @click.native="AddFriend(index,item.user.tokenuser,item.user.type, item)" class="CSChatThai text-transform">{{$t('AnswerQuestion.addFriend')}}</v-btn>
                      </v-list-tile-action>
                      </v-list-tile>
                      <v-divider></v-divider>
                    </template>
                  </v-list>
                  <v-list v-else><h4 style="margin-top: 40px; justify-content: center; display: flex;">{{$t('LeftSide.addFiend.nodata', {key: ''})}}</h4></v-list>
                  </v-tab-item>
                  <!-- list company -->
                  <!-- <v-tab-item id="tab-2">
                    <v-list two-line style="overflow-y: scroll; max-height: 40vh;" v-if="sizeBusiness !== 0">
                    <template v-for="(item, index) in listbusiness">
                      <v-list-tile>
                        <v-list-tile-avatar >
                          <img v-if="item.user.profilepicture" :src="item.user.profilepicture" class="alligator-turtle">
                          <img  v-else-if="item.user.type === 'company'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                          <img  v-else-if="item.user.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                          <img  v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                        <v-list-tile-title v-html="item.user.name" style="width: 18em;"></v-list-tile-title>
                      </v-list-tile-content>

                      <v-list-tile-action>
                        <v-btn color="blue darken-1" v-if="item.relation == 'friend'" flat @click.native="chat(item.user.tokenroom)" class="CSChatThai">แชท</v-btn>
                        <v-btn color="blue darken-1" v-else-if="item.relation == 'request'" flat @click.native="AcceptReq(index,item.user.tokenuser,item.user.type,item.user.business_id)" class="CSChatThai">ตอบรับคำขอ</v-btn>
                        <v-btn color="red darken-1" v-else-if="item.relation == 'sendrequest'" flat @click.native="RemoveReq(index,item.user.tokenuser,item.user.business_id)" class="CSChatThai">ยกเลิกคำขอ</v-btn>
                        <v-btn color="red darken-1" v-else-if="item.relation == 'block'" flat @click.native="unblock(index,item.user.tokenuser,item.user.tokenroom)" class="CSChatThai">ยกเลิกบล็อค</v-btn>
                        <v-btn color="blue darken-1" v-else-if="item.relation == 'self'" flat @click.native="closeDialog()" class="CSChatThai">ตกลง</v-btn>
                        <v-btn color="blue darken-1" v-else-if="item.relation == 'unknown' || item.relation == 'unfriend'" flat @click.native="AddFriend(index,item.user.tokenuser,item.user.type,item.user.business_id)" class="CSChatThai">เพิ่มเพื่อน</v-btn>
                      </v-list-tile-action>
                      </v-list-tile>
                      <v-divider></v-divider>
                    </template>
                  </v-list>
                  <v-list v-else><h4 style="margin-top: 40px; justify-content: center; display: flex;">ไม่พบข้อมูลผู้ใช้</h4></v-list>
                  </v-tab-item> -->
                  <!-- list goverment -->
                  <!-- <v-tab-item id="tab-3">
                    <v-list two-line style="overflow-y: scroll; max-height: 40vh;" v-if="sizeGoverment !== 0">
                    <template v-for="(item, index) in listgoverment">
                      <v-list-tile>
                        <v-list-tile-avatar >
                          <img v-if="item.user.profilepicture" :src="item.user.profilepicture" class="alligator-turtle">
                          <img  v-else-if="item.user.type === 'government'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                          <img  v-else-if="item.user.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                          <img  v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                        <v-list-tile-title v-html="item.user.name" style="width: 18em;"></v-list-tile-title>
                      </v-list-tile-content>

                      <v-list-tile-action>
                        <v-btn color="blue darken-1" v-if="item.relation == 'friend'" flat @click.native="chat(item.user.tokenroom)" class="CSChatThai">แชท</v-btn>
                        <v-btn color="blue darken-1" v-else-if="item.relation == 'request'" flat @click.native="AcceptReq(index,item.user.tokenuser,item.user.business_id)" class="CSChatThai">ตอบรับคำขอ</v-btn>
                        <v-btn color="red darken-1" v-else-if="item.relation == 'sendrequest'" flat @click.native="RemoveReq(index,item.user.tokenuser,item.user.business_id)" class="CSChatThai">ยกเลิกคำขอ</v-btn>
                        <v-btn color="red darken-1" v-else-if="item.relation == 'block'" flat @click.native="unblock(index,item.user.tokenuser,item.user.tokenroom)" class="CSChatThai">ยกเลิกบล็อค</v-btn>
                        <v-btn color="blue darken-1" v-else-if="item.relation == 'self'" flat @click.native="closeDialog()" class="CSChatThai">ตกลง</v-btn>
                        <v-btn color="blue darken-1" v-else-if="item.relation == 'unknown' || item.relation == 'unfriend'" flat @click.native="AddFriend(index,item.user.tokenuser,item.user.type,item.user.business_id)" class="CSChatThai">เพิ่มเพื่อน</v-btn>
                      </v-list-tile-action>
                      </v-list-tile>
                      <v-divider></v-divider>
                    </template>
                  </v-list>
                  <v-list v-else><h4 style="margin-top: 40px; justify-content: center; display: flex;">ไม่พบข้อมูลผู้ใช้</h4></v-list>
                  </v-tab-item> -->
                </v-tabs-items>
            </v-tabs>

            <v-dialog v-model="dialogPassword" max-width="400">
              <v-card>
                <v-card-title class="headline">{{$t('LeftSide.addFiend.headerCheckpass')}}
                  <v-spacer></v-spacer>
                  <v-btn icon @click="close_dialog_pass">
                    <v-icon style="color: black !important; font-size: 25px !important;">clear</v-icon>
                  </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-text-field
                    @keyup.enter.exact="check_password_bot"
                    solo
                    :label="$t('LeftSide.addFiend.placeholderPassword')"
                    v-model="password"
                    clearable
                    hide-details
                    >
                  </v-text-field>
                  <span style="color: red; padding-left: 10px;">{{message_error}}</span>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="clear_dialog_pass" class="btncancle">
                    {{$t('AnswerQuestion.clear')}}
                  </v-btn>

                  <v-btn @click="check_password_bot" class="btnaddfriend" :loading="loading">
                    {{$t('AnswerQuestion.addFriend')}}
                  </v-btn>
                </v-card-actions>
              </v-card>
          </v-dialog>

          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
</div>
</vue100vh>
</template>
<script>
import { sync } from 'vuex-pathify'
import { Decode } from '@/services'
import vue100vh from 'vue-100vh'
export default {
  data: () => ({
    statussearch: '',
    search: '',
    token: '',
    TypeSearch: 'email',
    tokenFriend: '',
    filename: '',
    webbackend: '',
    listuser: [],
    listbot: [],
    listbusiness: [],
    listgoverment: [],
    business_id_user: '',
    type: '',
    dialogPassword: false,
    message_error: '',
    password: '',
    infor_bot: {},
    loading: false
  }),
  components: {
    vue100vh
  },
  methods: {
    check_password_bot () {
      this.message_error = ''
      this.loading = true
      this.axios.post(process.env.APImanage + '/check_password_bot', {tokenBot: this.infor_bot.tokenbot, password: this.password}).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          if (response.data.message === 'correct password') {
            this.axios.post(process.env.APInew_addfriend, {tokenfriend: this.infor_bot.tokenbot, tokenuser: this.token}).then((response) => {
              if (response.data.status === 'success') {
                this.dialogPassword = false
                this.loading = false
                this.password = ''
                this.listbot[this.infor_bot.index].relation = 'friend'
                this.listbot[this.infor_bot.index].user.tokenroom = response.data.tokenroom
              }
            })
          } else {
            this.loading = false
            this.message_error = this.$t('LeftSide.addFiend.messageCheckbot')
            // console.log(response.data.message)
          }
        }
      })
    },
    close_dialog_pass () {
      this.dialogPassword = false
      this.message_error = ''
      this.password = ''
      this.infor_bot = {}
    },
    clear_dialog_pass () {
      this.message_error = ''
      this.password = ''
    },
    toPage () {
      this.$router.go(-1)
    },
    closeDialog () {
      this.$emit('closeDialogAddFriend', false)
      this.search = ''
      this.tokenFriend = ''
      this.statussearch = ''
    },
    searchuser () {
      this.listbot = []
      this.listuser = []
      this.axios.post(process.env.APImanage + '/searchusernontype3', {tokenuser: this.token, key: this.search}).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          if (response.data['listuser'].length !== 0 || response.data['listBot'].length !== 0) {
            this.listuser = response.data['listuser']
            this.listbot = response.data['listBot']
            this.statussearch = 'found'
          } else {
            this.statussearch = 'not found'
          }
        } else {
          this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'warning')
        }
      })
    },
    AcceptReq (index, item) {
      this.axios.post(process.env.APInew_acceptfriend, {tokenfriend: item.user.tokenuser, tokenuser: this.token}).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.listuser[index].relation = 'friend'
          this.$emit('updatelistreq', {
            event: 'accept',
            tokenuser: item.user.tokenuser,
            name: item.user.name,
            profilepicture: item.user.profilepicture,
            email: item.user.email,
            state: 'friend',
            status: item.user.status,
            type: item.user.type,
            tokenroom: response.data.tokenroom,
            timestamp: response.data.timestamp
          })
          // this.$store.dispatch('listFriend', JSON.stringify(this.listSearch))
          // this.$store.dispatch('Request', 'acceptrequest' + this.listSearch + ' ' + Math.random())
        } else {
          this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'warning')
        }
      })
    },
    RemoveReq (index, item) {
      this.axios.post(process.env.APImanage + '/removerequestfriend', {tokenfriend: item.user.tokenuser, tokenuser: this.token}).then((response) => {
        if (response.data.status === 'success') {
          // console.log(response.data)
          this.listuser[index].relation = 'unknown'
          this.$emit('updatelistreq', {
            event: 'removeReq',
            tokenuser: item.user.tokenuser
          })
          // this.$emit('updatelistreq', tokenfriend)
          // this.$store.dispatch('sendRequest', 'removerequestfriend' + tokenfriend)
        }
      })
    },
    AddFriend (index, tokenfriend, typeuser, item) {
      if (typeuser === 'user') {
        this.axios.post(process.env.APInew_addfriend, {tokenfriend: tokenfriend, tokenuser: this.token}).then((response) => {
          if (response.data.status === 'success') {
            if (typeuser === 'user') {
              this.listuser[index].relation = 'sendrequest'
            }
          }
        })
      } else if (typeuser === 'bot' && item.user.is_password !== '0') {
        this.dialogPassword = true
        this.infor_bot = { 'tokenbot': tokenfriend, 'index': index }
      } else {
        this.axios.post(process.env.APInew_addfriend, {tokenfriend: tokenfriend, tokenuser: this.token}).then((response) => {
          if (response.data.status === 'success') {
            this.listbot[index].relation = 'friend'
            this.listbot[index].user.tokenroom = response.data.tokenroom
          }
        })
      }
    },
    AddFriendCollab (index, item, state) {
      // console.log(item)
      // console.log(index)
      this.loading = true
      this.axios.post(process.env.APIgo_api + `/v1/add-friend-accept`, {tokenfriend: item.tokenuser, tokenuser: this.token}).then((response) => {
        if (response.data.status === 'success') {
          this.loading = false
          if (state === 'true') {
            this.chat(response.data.tokenroom)
          } else {
            this.listuser[index].relation = 'friend'
            this.listuser[index].user.tokenroom = response.data.tokenroom
          }
        } else {
          this.loading = false
          this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'warning')
        }
      }).catch(error => {
        console.log(error)
        this.loading = false
        this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'warning')
      })
    },
    chat (room) {
      // this.$emit('closeFriend', false)
      // this.$store.dispatch('tokenRoom', room)
      // localStorage.setItem('room', room)
      // this.closeDialog()
      this.$router.push('/mobile/room/' + room)
      // this.$store.dispatch('changeFriend', room)
      // this.$store.dispatch('changeRightTool', 'Friend')
    },
    findWithAttr (array, attr, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
          return i
        }
      }
      return -1
    },
    unblock (index, item, type) {
      this.$swal({
        title: this.$t('Alert.Sure'),
        text: this.$t('Alert.Unblocking',{name: item.user.name}),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.APImanage + '/unblockfriend', { tokenfriend: item.user.tokenuser, tokenuser: this.token, tokenroom: item.user.tokenroom }).then((response) => {
            // console.log(response.data)
            if (response.data['status'] === 'success') {
              this.$swal(
                'Unblocked!',
                this.$t('Alert.Success.unblock'),
                'success'
              )
              // this.listSearch[index].relation = 'friend'
              // this.$http.post(process.env.APImanage + '/web/getlistblockfriend', {tokenuser: this.token}).then((response) => {
              //   this.$store.dispatch('listFriend', 'listBlockFriend' + tokenfriend)
              // })
              if (type === 'user') {
                this.listuser[index].relation = 'friend'
              } else if (type === 'bot') {
                this.listbot[index].relation = 'friend'
              }
              // emit ย้อนกลับได้
              var itemfriend = item.user
              itemfriend.event = 'unblock_friend'
              this.$emit('blockevent', itemfriend)
            }
          })
        }
      })
    }
  },
  created () {
    var decoded = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    this.filename = localStorage.getItem('profilepicture')
    this.webbackend = process.env.API
    this.type = localStorage.getItem('type_user')
    this.business_id_user = localStorage.getItem('business_id')
    this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
  },
  watch: {
    search () {
      this.listuser = []
      this.listbot = []
      this.statussearch = ''
    },
    event_accept_friend (data) {
      // console.log(data)
      this.socketaccept_friend = data
    }
  },
  computed: {
    ...sync('*')
  }
}
</script>
<style type="text/css" scoped>
.text-transform {
  text-transform: none !important;
}
>>>.v-card__title {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  /* padding: 16px; */
  padding-left: 22px;
  padding-top: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
}
>>>.headline {
  font-size: 20px!important;
  line-height: 32px!important;
}
.btncancle {
  border-style: solid !important;
  background-color: #eee !important;
  border-radius: 7px !important;
  color: #27303e !important;
  box-shadow: none !important;
  text-transform: capitalize !important;
  border-color: white !important;
}
.btnaddfriend {
  border-style: solid !important;
  background-color: #1976d2 !important;
  border-radius: 7px !important;
  color: white !important;
  box-shadow: none !important;
  text-transform: capitalize !important;
}
.text2 {
  white-space: nowrap;
  width: 107px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bgsearch {
  color: white !important;
  margin-top: 5vh;
}
>>>.v-toolbar {
  /* box-shadow: none; */
  box-shadow: 0 2px 0px -1px hsla(0,0%,100%,.12), 0 0px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12);
}
>>> .cyan {
  background-color: white !important;
  border-color: white !important;
}
>>> .v-input__slot {
  border-width: thin !important;
  border-color: #777777d1 !important;
  border-style: solid !important;
  border-radius: 20px !important;
  box-shadow: none !important;
}

.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}
.application .theme--light.input-group input, .application .theme--light.input-group textarea, .theme--light .input-group input, .theme--light .input-group textarea {
    /* color: rgba(0,0,0,.87); */
    color: #53ceff !important;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
input[type=textadd] {

    width: 100%;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
    background-color: white;
    /*background-image: url('../assets/image/group.png');*/
    background-position: 10px 10px;
    background-repeat: no-repeat;
    padding: 12px 12px 12px 12px;
    -webkit-transition: width 0.4s ease-in-out;
    transition: width 0.4s ease-in-out;
}
>>>.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px !important;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.BGwhite {
  background-color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/manage/Addfriend.vue